
<div class="c__card">
  <div class="c__content-wrapper">
    @if (userInfo) {
      <sd-title [titleLevel]="titleLevel" customClass="c__address-name brand--h5" data-testid="card-title">
        {{ userInfo?.firstName + " " + userInfo?.lastName  }}
      </sd-title>
    }
    <p class="is-caption" data-testid="card-body">
      <span>{{ userInfo?.email }}</span>
      <span>{{userInfo?.phone}}</span>
    </p>
    <button sd-button
      class="is-reset"
      type="button"
      [isSmall]="true"
      icon="icon-edit"
      [iconPos]="positionEnum.left"
      (click)="showEditInformationForm()"
      data-testid="edit-button"
    >
      <span>{{'relaypoint.update.user.info'|translate}}</span>
    </button>
  </div>
</div>
